<mat-select class="action-button" [formControl]="selectedForm" [panelWidth]="null">
  <mat-select-trigger>
    {{ selectedForm.value | uppercase }}
  </mat-select-trigger>
  <mat-option *ngFor="let lang of availableLanguages" [value]="lang">
    {{ lang | languageCodeLabel }}</mat-option
  >
</mat-select>
